// @flow
import api from 'tim-api';
import {
  brand as brandEndpoint
} from 'endPoints';

export const state: Object = {
  brands: []
};

export const getters = {
  brands: (state: Object) => state.brands
};

export const mutations = {
  SET_BRAND(state: Object, brands: Array<Object>) {
    state.brands = brands;
  }
};

export const actions = {
  fetchBrand({ commit }: Action) {
    return api.get(brandEndpoint).then(({ data }) => {
      commit('SET_BRAND', data.data);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
